import PageConfigProvider from "src/features/PageConfigProvider";
import { FilterFieldsKeys } from "./types/FilterFields";
import useGetListParams from "./hooks/useGetListParams";
import { customSx } from "src/utils/styling";
import { Box } from "src/components/MuiGenerals";
import Filter from "./components/Filter";
import Table from "./components/Table";
import { DivideLine } from "src/utils/HelperComp";
import { getAllLedgerBalanceMonitor } from "src/api/merchant";

function LedgerBalanceMonitor() {
  const { getListParams } = useGetListParams();
  return (
    <PageConfigProvider
      translatePrefix="ledgerBalanceMonitor"
      initFields={{
        [FilterFieldsKeys.ChainName]: "",
        [FilterFieldsKeys.Currency]: "",
        [FilterFieldsKeys.ClientId]: "",
      }}
      getListParams={getListParams}
      getTableDataApiFunc={getAllLedgerBalanceMonitor}
    >
      <Box sx={customSx.layoutBox}>
        <Filter />
        <DivideLine />
        <Table />
      </Box>
    </PageConfigProvider>
  );
}

export default LedgerBalanceMonitor;
